
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M29.4 0v57M37.74 56.28A45.54 45.54 0 0043.51 34a45.51 45.51 0 00-6.2-23M21.58 11a45.46 45.46 0 00-6.28 23.16c0 .85 0 1.69.07 2.53M16.83 54.43a24.05 24.05 0 0034.39-30.64M47.47 18A24.06 24.06 0 008.14 45.17M5.4 33.92h48M44.94 21.28A76.79 76.79 0 008.1 23"}}),_c('path',{attrs:{"d":"M24.17 47.89c1.53.09 3.07.13 4.62.13a76.36 76.36 0 0021.88-3.18M49.53 26.27a11.73 11.73 0 00-2.3-3.27A11.56 11.56 0 0044 20.71a11.87 11.87 0 003.28-2.31 11.59 11.59 0 002.29-3.26 11.91 11.91 0 002.31 3.27 11.77 11.77 0 003.26 2.3 11.69 11.69 0 00-5.57 5.56z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M15.33 57.53A22 22 0 0011 51.4a22 22 0 00-6.1-4.31 22 22 0 006.1-4.31 21.86 21.86 0 004.3-6.12 22.17 22.17 0 004.32 6.13 21.9 21.9 0 006.11 4.3 22.33 22.33 0 00-6.13 4.32 21.86 21.86 0 00-4.27 6.12z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    